import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useSearchParams } from 'react-router-dom';

import { QueryErrorResetBoundary } from '@tanstack/react-query';

import { FetchLoading } from '@/shared/component';

import {
  SearchResultList,
  SearchResultListErrorFallback,
} from '@/feature/search/component';

/**
 * TODO(global search): 라우트 개선 작업 완료 후 교체
 */
export default function SearchResultListSuspense() {
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={SearchResultListErrorFallback}
          resetKeys={[params]}
        >
          <Suspense fallback={<FetchLoading />}>
            <SearchResultList />
            {/* <SearchResultListWrapper /> */}
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
